import { SimpleHeader } from '@/components/header/SimpleHeader';
import { BannerApp } from '../home/components/BannerApp/BannerApp';
import { Container } from '@mui/material';
import { useEffect } from 'react';

export const DownloadApp = () => {
  const google_link = 'https://play.google.com/store/apps/details?id=com.medstation.medstation';
  const apple_link = 'https://apps.apple.com/br/app/medstation-app/id6743131481';

  const redirect = (url: string) => {
    setTimeout(() => {
      window.location.href = url;
    }, 100);
  };

  useEffect(() => {
    var userAgent = navigator.userAgent || navigator.vendor;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      redirect(google_link);
    }

    if (/android/i.test(userAgent)) {
      redirect(google_link);
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      redirect(apple_link);
    }
  }, []);

  return (
    <>
      <SimpleHeader />
      <Container sx={{ marginTop: '100px' }}>
        <BannerApp
          hideScheduleButton
          onScheduleClick={() => console.log('to aqui')}
        />
      </Container>
    </>
  );
};
